import { HomeComponent } from '@src/app/home/home.component';
import { AuthGuard } from './shared/guards/auth-guard.service';
import { AccountLayoutComponent } from './account-layout.component';
import { MainLayoutComponent } from './main-layout.component';
import { AccountGuard } from './shared/guards/account-guard.service';
import { Role } from './shared/Roles';
import { GuestQuestionComponent } from './guest-question/guest-question.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { VideoComponent } from './Videolayoutcomponent';
import { PrivacyPolicyComponent } from './privacyPolicy.component';
var ɵ0 = function () { return import("./account/account.module.ngfactory").then(function (m) { return m.AccountModuleNgFactory; }); }, ɵ1 = { preload: true }, ɵ2 = { role: Role.Admin, preload: true }, ɵ3 = function () { return import("./admin/admin.module.ngfactory").then(function (m) { return m.AdminModuleNgFactory; }); }, ɵ4 = { role: Role.Mentor, preload: true }, ɵ5 = function () { return import("./mantor/mantor.module.ngfactory").then(function (m) { return m.MantorModuleNgFactory; }); }, ɵ6 = { role: Role.Mentee, preload: true }, ɵ7 = function () { return import("./mantee/mantee.module.ngfactory").then(function (m) { return m.ManteeModuleNgFactory; }); };
export var routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            { path: '', component: HomeComponent },
            { path: 'guest/question', component: GuestQuestionComponent }
        ]
    },
    {
        path: 'accounts',
        component: AccountLayoutComponent,
        canActivateChild: [AccountGuard],
        loadChildren: ɵ0,
        data: ɵ1
    },
    {
        path: 'admin',
        canActivateChild: [AuthGuard],
        canLoad: [AuthGuard],
        data: ɵ2,
        loadChildren: ɵ3
    },
    {
        path: 'mentor',
        canActivateChild: [AuthGuard],
        data: ɵ4,
        canLoad: [AuthGuard],
        loadChildren: ɵ5
    },
    {
        path: 'mentee',
        canActivateChild: [AuthGuard],
        data: ɵ6,
        canLoad: [AuthGuard],
        loadChildren: ɵ7
    },
    {
        path: 'VideoPlayer',
        component: VideoComponent,
        children: [
            { path: '', component: VideoPlayerComponent },
        ]
    },
    {
        path: 'privacypolicy',
        component: PrivacyPolicyComponent,
        children: [
            { path: '', component: PrivacyPolicyComponent },
        ]
    },
    {
        path: '**',
        redirectTo: ''
    },
];
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
